export var InjectQueryPlugin = function (client) {
    client.on('start', function () {
        var bid = client.config().bid;
        var sender = client.getSender();
        sender.setEndpoint(sender.getEndpoint() + ("?biz_id=" + bid));
    });
};
//# sourceMappingURL=inject-query.js.map